import { render, staticRenderFns } from "./Buywh12.vue?vue&type=template&id=7f225f32&scoped=true&"
import script from "./Buywh12.vue?vue&type=script&lang=js&"
export * from "./Buywh12.vue?vue&type=script&lang=js&"
import style0 from "./Buywh12.vue?vue&type=style&index=0&id=7f225f32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f225f32",
  null
  
)

export default component.exports